import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=20dbf03d&scoped=true"
import script from "./CalendarEvents.vue?vue&type=script&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&lang=js"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&id=20dbf03d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dbf03d",
  null
  
)

export default component.exports